import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';

const DataComponentDisplayControl = ({ data = [], type, onChange }) => {
    const [displayData] = useState([
        {type: 'table', icon: 'fa-table'},
        ...data
    ]);

    const onClick = useCallback((button) => {
        const buttonType = button.props['data-type'];

        if (type === buttonType) {
            return;
        }

        if (onChange) {
            onChange(buttonType);
        }
    }, [type, onChange]);

    return (
        <div className="btn-group m-b">
            {displayData.map(item => (
                <Button
                    key={item.type}
                    default={true}
                    extraClass={{'active': item.type === type}}
                    text={(<Icon name={item.icon} />)}
                    data-type={item.type}
                    onClick={onClick}
                />
            ))}
        </div>
    );
};

DataComponentDisplayControl.propTypes = {
    data: PropTypes.array,
    type: PropTypes.string,
    onChange: PropTypes.func
};

DataComponentDisplayControl.defaultProps = {
    data: [],
    type: 'table',
    onChange: () => {}
};

export default DataComponentDisplayControl;
